// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-style[data-v-692d9e87]{border-radius:25px;margin-bottom:1em}.label-style[data-v-692d9e87]{background-color:#8a2be2;color:#fff;font-size:14px;margin:1em .9em;padding:.7em;border-radius:25px}", ""]);
// Exports
module.exports = exports;
